module.exports = __webpack_public_path__ + "img/option-survey-station.b72e4460.png";